export const reduxKey = '@@TAG_INPUT';
